module.exports = __webpack_public_path__ + "img/horizontal_7_5_pp3_8017.caff452b.png";